import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCertificate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.75 1.5C18.2688 1.5 19.5 2.73122 19.5 4.25V7.19922C21.2873 8.17443 22.5 10.0705 22.5 12.25C22.5 14.108 21.6173 15.7584 20.25 16.8096V22.1465C20.25 22.8849 19.4447 23.3408 18.8115 22.9609L17 21.874L15.1885 22.9609C14.5553 23.3408 13.75 22.8849 13.75 22.1465V21.5H4.75C3.23122 21.5 2 20.2688 2 18.75V4.25C2 2.73122 3.23122 1.5 4.75 1.5H16.75ZM18.75 17.6416C18.127 17.8728 17.4534 18 16.75 18C16.2309 18 15.7283 17.9297 15.25 17.8008V21.1748L16.6143 20.3564L17 20.125L17.3857 20.3564L18.75 21.1748V17.6416ZM4.75 3C4.05964 3 3.5 3.55964 3.5 4.25V18.75C3.5 19.4404 4.05964 20 4.75 20H13.75V17.1553C12.1007 16.1445 11 14.3261 11 12.25C11 9.07436 13.5744 6.5 16.75 6.5C17.1794 6.5 17.5975 6.54844 18 6.6377V4.25C18 3.55964 17.4404 3 16.75 3H4.75ZM16.75 8C14.4028 8 12.5 9.90279 12.5 12.25C12.5 14.5972 14.4028 16.5 16.75 16.5C19.0972 16.5 21 14.5972 21 12.25C21 9.90279 19.0972 8 16.75 8Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .3
	})
});
export default SvgCertificate;
